import React from 'react';
import './fixed.css';
import { profile } from '../../data/profile';

const FixedEmail = () => (
  <div className="fixed__email">
    <a href={`mailto:${profile.email}`}>{profile.email}</a>
  </div>
);

export default FixedEmail;
